import React, { createContext, useContext, useEffect, useRef } from "react"
import JWTApi, { IUser } from "../../libs/login/JWTApi"
import LoginDlg from "./LoginDlg"
import { useOverlay } from "../Overlay/OverlayProvider"
import Form from "../Form/Form"

const DIALOG_id = "loginDialog"
type TLoginContext = {
    login:(onLogin?:Function) => void
    logout:() => void
}

interface TLoginContextProps {
    api:JWTApi
    children:JSX.Element
    required?:boolean
    onAuth?:(user:IUser) => void
}

const LoginContext = createContext<TLoginContext>({} as any)
export const useLogin = () => useContext(LoginContext)

export default function LoginProvider(props:TLoginContextProps) {
    const {api,children,required,onAuth} = props
    const {addOverlay,popOverlay,hasOverlay} = useOverlay()

    const login = (onLogin?:Function) => {
        if (hasOverlay(DIALOG_id)) return
        addOverlay(DIALOG_id, {children:<Form><LoginDlg overlayId={DIALOG_id} api={api} onLogin={onLogin}/></Form>, className:"dialog", modal:!!required})
    }

    const _onAuth = async (user:IUser|null) => {
        if (!user && required) login()
        else if (!!user) {
            popOverlay(DIALOG_id)
            onAuth?.(user)
        }
    }

    const logout = () => api.logout()

    useEffect(() => {
        api.onAuth(_onAuth)
        api.auth()
        if (!api.isLoggedIn && required) login()
        return () => { api.removeListener("auth", _onAuth) }
    }, [])

    return <LoginContext.Provider value={{login,logout}}>
        {children}
    </LoginContext.Provider>
}